import axios from 'axios';

import { getApiBaseUrl } from '../../utils/environment';

// 10s covers the /entitlements cold path: edge-function cold start plus the
// BFF's serial downstream chain (Secrets Manager, OAuth, Optimizely,
// artifacts, permissions).
const DEFAULT_API_TIMEOUT = 10000;

export const axiosClient = axios.create({
  baseURL: getApiBaseUrl(),
  timeout: DEFAULT_API_TIMEOUT,
  transitional: {
    clarifyTimeoutError: true,
  },
});
